import styled from 'styled-components';

import CarrierEditModal from './component';

export default styled(CarrierEditModal)`
  .carrier-edit-modal {
    display: flex;
    flex-direction: column;
    overflow: hidden;

    input {
      height: auto;
      width: 100%;

      &--inline {
        height: 40px;
      }
    }

    &__field {
      width: 100%;
    }

    &__section {
      margin-bottom: 0;

      &--dark {
        background-color: var(--grey200);
      }
    }

    &__title {
      color: var(--grey900);
      font-weight: bold;
    }

    &__banned-field {
      margin: 1rem 0;
      width: 100%;
    }

    &__doc-checkbox {
      display: block;
      margin-bottom: 15px;
      &:last-child {
        margin-bottom: 0;
      }
    }

    &__footer-actions {
      display: flex;
      justify-content: space-between;
    }

    &__delete-btn {
      button {
        color: var(--error700);
        padding: 0;
      }
    }

    &__tag {
      background-color: var(--grey100);
      text-transform: uppercase;
    }

    &__general-errors {
      background: var(--grey200);
      border: 1px solid var(--grey200);
      color: var(--error700);
      display: flex;
      margin: -2rem -3rem 2rem;
      padding: 0.5rem 3rem;
    }

    &__ibanField {
      position: relative;
    }

    &__ibanCheck {
      color: $color-feeback-ok;
      position: absolute;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      display: block;
      z-index: 9;
      right: 10px;
      top: 50%;
      margin-top: -12px;
    }
  }
`;
